export const reviewsData = [
  {
    id: 1,
    name: '田中 美咲',
    age: 35,
    gender: '女性',
    rating: 5,
    comment: '働きながら子育てをしているので、疲れやすかったのですが、このサプリメントを飲み始めてから朝の目覚めが良くなりました。家族の健康も考えて、これからも続けたいと思います。',
    avatar: 'https://public.readdy.ai/ai/img_res/9ba9bab91085cf9c096752d05aca6f72.jpg',
  },
  {
    id: 2,
    name: '佐藤 健一',
    age: 58,
    gender: '男性',
    rating: 5,
    comment: '定年を控えて健康維持を意識するようになりました。シニア向けのサプリメントは飲みやすく、関節の調子も良好です。岡山の会社ということで安心感もあります。',
    avatar: 'https://readdy.ai/api/search-image?query=mature%20japanese%20businessman%20in%20his%20late%20fifties%20with%20gentle%20smile%20wearing%20smart%20casual%20clothing%20against%20clean%20white%20background%20natural%20daylight%20portrait%20photography%20professional%20quality&width=120&height=120&seq=review2&orientation=squarish',
  },
  {
    id: 3,
    name: '山本 由美',
    age: 42,
    gender: '女性',
    rating: 5,
    comment: '妊娠中に必要な栄養素がバランスよく配合されていて、安心して飲むことができました。出産後も体調管理のために続けています。丁寧な対応にも感謝しています。',
    avatar: 'https://readdy.ai/api/search-image?query=kind%20japanese%20woman%20in%20her%20early%20forties%20with%20warm%20smile%20wearing%20comfortable%20clothing%20against%20soft%20white%20background%20natural%20lighting%20portrait%20photography%20high%20resolution&width=120&height=120&seq=review3&orientation=squarish',
  },
  {
    id: 4,
    name: '鈴木 大輔',
    age: 28,
    gender: '男性',
    rating: 5,
    comment: '仕事が忙しく食生活が乱れがちでしたが、若年層向けのサプリメントで栄養バランスを整えられています。価格も手頃で続けやすいのが嬉しいです。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20japanese%20man%20in%20his%20late%20twenties%20with%20friendly%20smile%20wearing%20casual%20modern%20clothing%20against%20clean%20white%20background%20natural%20daylight%20portrait%20photography%20sharp%20focus&width=120&height=120&seq=review4&orientation=squarish',
  },
];